<div class="{{'role-selection ' + roleClass}}" [ngClass]="hasError ? 'error-highlight' : ''">
    @if (!lastModified) {
<div class="info" title="{{localize(langSection.LocationUserPage, langText.LastUpdated)}}:">
    </div>
}
    @if (lastModified) {
<div class="info"
        title="{{localize(langSection.LocationUserPage, langText.LastUpdated)}}: {{lastModified.lastUpdatedAt | localizedDate: 'MM/DD h:mm A':'yyyy/MM/DD HH:mm':offset}} {{localize(langSection.Term, langText.By) | lowercase}} {{lastModified.lastUpdatedBy}}">
    </div>
}
    <ups-select [list]="roleList" [value]="role" (change)="onRoleChange($event.target.value)"
        [revertSelection]="revertSelection.asObservable()"></ups-select>
    @if (hasError) {
<span class="error-icon"></span>
}
</div>